import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-main-menu-toolbar',
    imports: [CommonModule, MatToolbarModule, RouterLink],
    templateUrl: './main-menu-toolbar.component.html',
    styleUrls: ['./main-menu-toolbar.component.scss']
})
export class MainMenuToolbarComponent {

}
